module.exports = __webpack_public_path__ + "media/react/high_school/pages/assignments/subject_block/assets/green_check_2x-703ccb03aab543dee6a3be032110ca56.png";